import FlowEditor from 'components/FlowEditor/FlowEditor';
import { FlowContext } from 'contexts/FlowContext';
import { EDITOR_PATH_ID, ENTITY_PATH } from 'contracts/constants';
import type { FC } from 'react';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { getParams } from 'utils';

interface FlowEditorContainerProps {
  isEditable: boolean;
}
const FlowEditorContainer: FC<FlowEditorContainerProps> = ({ isEditable }) => {
  const ctx = useContext(FlowContext);
  const { pathname } = useLocation();
  const params: any = getParams(pathname, [EDITOR_PATH_ID, ENTITY_PATH]);

  // if (loadingFlow) {
  //   return <H4>Loading...</H4>;
  // }

  return <FlowEditor isEditable={isEditable} />;
};

export default FlowEditorContainer;
